import React from 'react'
import {ProgressBar} from 'react-mdl'
import {ItemSummary} from 'components'
import {createComparator} from 'utils'

import './dashboard.css'

// Pure presentational component
export default class Dashboard extends React.PureComponent {

  render() {
    const {items} = this.props
    const itemsKeys = getKeysSortedByChild(items, 'order')

    if (!itemsKeys.length) return <ProgressBar className='pageLoader' title='loading from firebase' indeterminate/>

    return (
      <div className="posts-container mdl-cell mdl-cell--12-col mdl-grid">

        <div className='row full'>
          <div className='warning'>
            <p>
              - Try clicking on an item tier to see how this site works.<br/>
              - Once you insert your own bid, it will display in the "My Offers" tab<br/>
              - Don't forget to set your contact details in "My Profile"
            </p>
          </div>
        </div>

      {
        itemsKeys.map(
          (key, ix) => <ItemSummary key={ix} {...items[key]} id={key}/>
        )
      }

      </div>
    )
  }
}

function getKeysSortedByChild(items, childName) {
  const compareByChild = createComparator(childName)
  return Object.keys(items).sort((left, right) => compareByChild(items[left], items[right]))
}



// WEBPACK FOOTER //
// ./src/client/pages/Dashboard.jsx